import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Site offer popup — "hand over your old fan, get ₹250".
 * Shows on every page load (after a short delay so it doesn't fight the
 * initial render).
 */
function OldFanOfferPopup() {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setOpen(true), 1500);
    return () => clearTimeout(t);
  }, []);

  const close = () => {
    setOpen(false);
  };

  const shopFans = () => {
    close();
    navigate('/shop?category=FANS');
  };

  if (!open) return null;

  return (
    <div
      onClick={close}
      style={{
        position: 'fixed', inset: 0, zIndex: 4000,
        background: 'rgba(0,0,0,0.55)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        padding: 16,
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          position: 'relative', width: '100%', maxWidth: 420,
          background: '#fff', borderRadius: 16, overflow: 'hidden',
          boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
        }}
      >
        <button
          onClick={close}
          aria-label="Close"
          style={{
            position: 'absolute', top: 10, right: 12, border: 'none',
            background: 'rgba(255,255,255,0.85)', borderRadius: '50%',
            width: 32, height: 32, fontSize: 18, cursor: 'pointer', color: '#4A1507',
          }}
        >
          ×
        </button>

        <div style={{
          background: 'linear-gradient(135deg, #4A1507 0%, #7a2a12 100%)',
          color: '#fff', padding: '28px 24px 22px', textAlign: 'center',
        }}>
          <div style={{ fontSize: 40, lineHeight: 1 }}>♻️</div>
          <h2 style={{ margin: '12px 0 4px', fontSize: 24, fontWeight: 800 }}>
            Old Fan? Get <span style={{ color: '#ffd27a' }}>₹250!</span>
          </h2>
          <p style={{ margin: 0, opacity: 0.9, fontSize: 14 }}>Exchange offer · Local Thrissur delivery</p>
        </div>

        <div style={{ padding: '22px 24px 24px', textAlign: 'center' }}>
          <p style={{ margin: '0 0 14px', color: '#374151', fontSize: 15, lineHeight: 1.5 }}>
            Buy <strong>any fan</strong> from Ceedees and hand us your <strong>old fan</strong> when
            we deliver — get <strong>₹250 back</strong> as a coupon or cash on the spot.
          </p>
          <p style={{ margin: '0 0 18px', color: '#6b7280', fontSize: 13 }}>
            Available on our own home delivery within Thrissur (no courier orders).
          </p>
          <button
            onClick={shopFans}
            style={{
              width: '100%', background: '#4A1507', color: '#fff', border: 'none',
              borderRadius: 10, padding: '14px 20px', fontSize: 16, fontWeight: 700,
              cursor: 'pointer',
            }}
          >
            🌀 Shop Fans
          </button>
          <button
            onClick={close}
            style={{
              width: '100%', background: 'transparent', color: '#6b7280', border: 'none',
              marginTop: 8, padding: 8, fontSize: 13, cursor: 'pointer',
            }}
          >
            Maybe later
          </button>
        </div>
      </div>
    </div>
  );
}

export default OldFanOfferPopup;
